import { Component, OnInit, ElementRef, ViewChild, Input, EventEmitter, HostListener, OnDestroy, Renderer2, AfterViewInit, Inject } from '@angular/core';

// for material slide component etc.
import 'hammerjs';

import { UiHelper } from '@helpers/ui.helper';
import { LocalizationService } from '@services/localization.service';
import { ApiService } from '@services/api.service';
import { SignalrServiceLegacy } from '@services/signalr.service.legacy';
import { DataHelper } from '@helpers/data.helper';
import { Router } from '@angular/router';
import { LEAGUESLIDER, environment } from '@environments/environment';
import { UserHelper } from '@helpers/user.helper';

import { MatDialog } from '@angular/material/dialog';
import { TransactionsDialog } from '@components/transactions.dialog';
import { BehaviorSubject, Subscription } from 'rxjs';
import { HomePageDialog } from '@components/home-page-dialog';
import { OddModel } from '@components/live-upcoming.component';
import { DOCUMENT } from '@angular/common';
import { TranslatePipe } from '@pipes/translate.pipe';
import { sportsSvgList } from '@app/constants/svgUrl.constant';
declare let swRegister: any;

@Component({
  selector: 'main-home-b500',
  templateUrl: './home-b500.component.html',
})
export class HomeB500Component implements OnInit, AfterViewInit, OnDestroy {
  topCountries = [];
  selectedSportId = 1;
  _dayFilter = 300;
  // ALL Subscriptions
  private _subscriptions: Subscription[] = [];
  public sportsSvgList = sportsSvgList;

  homeHighlightData = [];

  homeLiveData;
  mainData = [];

  isSignIn = false;

  insicstatus = '2';
  selectedTab = 'hightlights';
  leagueSlider = [
    {
      FileName: 'angular/dist/assets/images/league/premiere.svg',
      route: '/league',
      TourId: '107',
      CatId: '1',
    },
    // {
    //   FileName: 'angular/dist/assets/images/league/Bundesliga_logo.svg',
    //   route: '/league',
    //   TourId: "16",
    //   CatId: "13"
    // },
    {
      FileName: 'angular/dist/assets/images/league/LaLiga.svg',
      route: '/league',
      TourId: '128',
      CatId: '15',
    },
    {
      FileName: 'angular/dist/assets/images/league/serie-a-seeklogo.com.svg',
      route: '/league',
      TourId: '236',
      CatId: '14',
    },
    {
      FileName: 'angular/dist/assets/images/league/spor_toto_super_lig_logo.svg',
      route: '/league',
      TourId: '133',
      CatId: '16',
    },
    {
      FileName: 'angular/dist/assets/images/league/Ligue_1_logo.svg',
      route: '/league',
      TourId: '167',
      CatId: '99',
    },
  ];

  oddMarketingB3000Value = [0, 2, 3, 5]; // B3000
  preMatchobservable = new BehaviorSubject<any>([]);
  _selectedOdds: OddModel[] = [];
  translator = new TranslatePipe(this._LocalizationService);
  isMobileView = false;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this._UiHelper.setResolution(window.innerWidth, window.innerHeight);
  }

  constructor(
    public _UiHelper: UiHelper,
    public _Localization: LocalizationService,
    private _LocalizationService: LocalizationService,
    private _ApiService: ApiService,
    private _SignalrServiceLegacy: SignalrServiceLegacy,
    public _DataHelper: DataHelper,
    private router: Router,
    public _UserHelper: UserHelper,
    public dialog: MatDialog,
    @Inject(DOCUMENT) private document: any
  ) {
    this._UiHelper.setFooterState(true);

    this._subscriptions.push(
      this._UserHelper.signInListener.subscribe(x => {
        if (x) {
          if (environment.transactionDialogIsActive) {
            this.openTransactionsDialog();
          }

          // console.warn(
          //   "this._UserHelper.customerUser",
          //   this._UserHelper.customerUser
          // );
          // if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))

          // if(!environment.mobile && environment.transactionDialogIsActive){
          //   //console.log('OPENNN-----')
          //   // this.openTransactionsDialog();
          // }
        }

        this.isSignIn = this._UserHelper.isSignedIn;
        // this._UiHelper.changeStatusRightMenu(false);
        this.getInsicStatus();
      })
    );
    this._DataHelper.homeSliderDataListener.subscribe(data => {
      this.processBanners(this._DataHelper.homeSliderData);
    });

    this._UiHelper.windowsWidth < 990 ? (this.isMobileView = true) : (this.isMobileView = false);
    this._UiHelper.windowResized.subscribe(x => {
      if (x.w <= 990) {
        this.isMobileView = true;
      } else {
        this.isMobileView = false;
      }
    });
  }

  flagopenTransactionsDialog = false;
  openTransactionsDialog(): void {
    if (this.flagopenTransactionsDialog) return;

    this.flagopenTransactionsDialog = true;

    const dialogRef = this.dialog.open(TransactionsDialog, {
      width: '400px',
      panelClass: 'transcation-Dialog',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      // //console.log('The dialog was closed',result);
    });
  }

  openHomePageDialog(): void {
    const dialogRef = this.dialog.open(HomePageDialog, {
      panelClass: 'home-page-dialog-class',
      width: '300px',
      height: '150px',
    });
    dialogRef.afterClosed().subscribe(result => {
      // //console.log('The dialog was closed',result);
    });
  }

  ngOnInit() {
    this.leagueSlider = LEAGUESLIDER;
    this.getSports();
  }

  ngAfterViewInit() {
    // var userAgent = window.navigator.userAgent;
    // if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
    //   //console.log('IOS--');
    //   this.openHomePageDialog();
    //
    // }
    // this.openHomePageDialog();

    this.homeLiveData = this._SignalrServiceLegacy.updateLiveFixtureData;
    this._subscriptions.push(
      this._SignalrServiceLegacy.updateLiveFixture.subscribe(x => {
        this.homeLiveData = x;
      })
    );

    this._UiHelper.setResolution(window.innerWidth, window.innerHeight);

    this._UiHelper.setNavbarTitle('', null, false);

    this.isSignIn = this._UserHelper.isSignedIn;
    if (this._UserHelper.isSignedIn) this.getInsicStatus();

    this.getHighlightsFixture();
    this._UiHelper.ScrollToTop();
  }

  ngOnDestroy(): void {
    // this._updateLiveFixture.unsubscribe();
    // CLEAR ALL SUBSCRIPTIONS
    this._subscriptions.forEach(sub => sub.unsubscribe());
  }

  showLocalNotification(title, body, swRegistration) {
    const options = {
      body,
      // here you can add more properties like icon, image, vibrate, etc.
    };
    swRegistration.showNotification(title, options);
  }

  async requestNotification() {
    const permission = await window.Notification.requestPermission();
    // value of permission can be 'granted', 'default', 'denied'
    // granted: user has accepted the request
    // default: user has dismissed the notification permission popup by clicking on x
    // denied: user has denied the request.

    this.showLocalNotification('This is title', 'this is the message', swRegister);

    ////console.log(permission);
    if (permission !== 'granted') {
      throw new Error('Permission not granted for Notification');
    }
  }

  onClickItem(e) {
    this.router.navigate([e.route], {
      queryParams: { CatId: e.CatId, TourId: e.TourId },
    });
    ////console.log('/' + e.route);
    //this._Router.navigate(['/eventdetail', e]);
  }

  getInsicStatus() {
    if (this._UserHelper.isSignedIn)
      if (this._UserHelper.customerUser != undefined && this._UserHelper.customerUser.CustomerId != undefined)
        this._ApiService.getInsicStatus().then(res => {
          this.insicstatus = res;
          this._UiHelper.setInsicStatus(res);
        });

    // console.warn("this._UserHelper.customerUser",this._UserHelper.customerUser)
  }

  // B3000

  isOpenLeagueMenu = true;
  isOpenSportsMenu = true;

  toggleLeagueMenu() {
    this.isOpenLeagueMenu = !this.isOpenLeagueMenu;
  }

  toggleSportsMenu() {
    this.isOpenSportsMenu = !this.isOpenSportsMenu;
  }

  getSports(__dayFilter = 300) {
    if (this._DataHelper.homeMainData == undefined || this._DataHelper.homeMainData.length == 0) {
      this._ApiService.getSports(__dayFilter).then(x => {
        this.mainData = x.map(x => {
          x['level'] = [];
          x['loading'] = false;
          x['state'] = false;
          return x;
        });
        this._DataHelper.homeMainData = this.mainData;
      });
    } else {
      this.mainData = this._DataHelper.homeMainData;
    }
  }

  getHighlightsFixture() {
    this._DataHelper.LeagueData = undefined;
    this.getPopularFixture('-2');

    this._subscriptions.push(
      this._ApiService.selectedOddsEvent.subscribe(x => {
        this._selectedOdds = x as OddModel[];
      })
    );
  }
  getPopularFixture(_sId) {
    const _catId = '0';
    this.preMatchobservable = this._DataHelper.homeHighlightsFixture;
    this._ApiService.getFixture(_sId, _catId).then(x => {
      this.preMatchobservable.next(x);
      this._DataHelper.homeHighlightsFixture.next(x);
    });
  }
  imageListArray = [];
  processBanners(e) {
    this.imageListArray = [];

    if (e == undefined) return;

    try {
      e.forEach(x => {
        const _data = {
          imageUrl: x.FileName,
          captions: x.Title ? x.Title : '',
          route: x.route,
          TourId: x.TourId,
          CatId: x.CatId,
          Link: x.Link,
        };

        this.imageListArray.push(_data);
      });
    } catch (e) {
      console.error(e);
    }
  }
  goBanner(e) {
    if (e.Link.indexOf('http') > -1) this.document.location.href = e.Link;
    else this.router.navigate([e.Link]);
  }
  getCountriesBySportsID(_sport, _index) {
    this.topCountries = [];
    this._DataHelper.selectedStorySportAllItem = _sport;
    this._DataHelper.selectedStoryIndex = _index;

    this.selectedSportId = _sport.SportId;
    this._DataHelper.mainData.forEach(element => {
      element['state'] = false;
    });

    this._ApiService
      .getCountriesBySportsID(this._dayFilter, _sport.SportId)
      .then(x => {
        this._DataHelper.mainData[_index].level = x
          .map(i => {
            if (i) {
              i['level'] = [];
              i['state'] = false;
              i['loading'] = false;
              i['allselected'] = false;
              return i;
            }
          })
          .filter(a => a !== undefined);
        this._DataHelper.mainData[_index]['state'] = true;
      })
      .catch(err => console.warn('level', err));
    this._DataHelper.setLeftMenuSportData(this._DataHelper.mainData, this._dayFilter);
  }

  showTabsMenuMobile(e?) {
    this._UiHelper.b3000SetAcountMobileState('open', 8, 0);
  }

  reSendConfirmation() {
    this._ApiService.getResendConfirmationMail().then();
  }
}
